import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { SsoMappingsAdminComponent } from "../../sso-mappings/sso.mappings.admin.component";
import { STUDENT_ENGAGEMENT_SSO_MAPPING_TYPE } from "../../../pojo/SsoMappingsI";

@TypeManagerDecorator("s25-ng-se-config-authentication-page")
@Component({
    selector: "s25-ng-se-config-authentication-page",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SsoMappingsAdminComponent],
    template: `
        <div class="c-padding--double se-config-page">
            <s25-ng-sso-mappings-admin [mappingType]="studentEngagementMappingType" />
        </div>
    `,
    styles: `
        :host {
            display: block;
        }
    `,
})
export class SeConfigAuthenticationPageComponent {
    readonly studentEngagementMappingType = STUDENT_ENGAGEMENT_SSO_MAPPING_TYPE;
}
